import { api } from "./api";
import { tokenReceived, userReceived, loggedOut } from "@/store/auth";
import authConfig from "@/config/auth.ts";
import type { LoginResponse } from "@/types/api/types.ts";


export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials: { email: string; password: string }) => ({
        url: authConfig.loginEndpoint,
        method: "POST",
        body: credentials,
        // credentials déjà géré dans baseQuery
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data }: { data: LoginResponse } = await queryFulfilled;

          dispatch(
            tokenReceived({
              accessToken: data.token,
            })
          );
          dispatch(userReceived(data.user));
        } catch (error) {
          // Handle error
        }
      },
    }),

    // Ce endpoint n'est plus appelé manuellement
    // Il est utilisé automatiquement par baseQueryWithReauth
    refresh: builder.mutation<{ token: string }, void>({
      query: () => ({
        url: authConfig.refreshTokenEndpoint,
        method: "POST",
      }),
    }),

    logout: builder.mutation({
      query: () => ({
        url: "/auth/logout",
        method: "POST",
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
        } finally {
          dispatch(loggedOut());
        }
      },
    }),

    getMe: builder.query({
      query: () => "/me",
      async onQueryStarted(arg, api) {
        try {
          const { data } = await api.queryFulfilled;
          api.dispatch(userReceived(data));
        } catch {
          api.dispatch(loggedOut());
        }
      },
    }),
  }),
});

export const { useLoginMutation, useLogoutMutation, useGetMeQuery } = authApi;
